export enum SaveType {
  SAVE = 'SAVE',
  SAVE_AND_CLOSE = 'SAVE_AND_CLOSE',
  SAVE_AND_CREATE_NEW = 'SAVE_AND_CREATE_NEW'
}
